// type TagEnum = 'success' | 'info' | 'warning' | 'danger' | 'cyan' | 'blue' | 'red' | 'orange' | 'green' | 'gray'

export var isShowOptions = [{
  value: true,
  label: '上架',
  tag: 'green'
}, {
  value: false,
  label: '下架',
  tag: 'red'
}];
export var defaultFormData = {
  platId: '',
  name: '',
  image: '',
  price: 0.01,
  isShow: false
};
export var formRules = {
  platId: [{
    required: true,
    trigger: ['blur', 'change'],
    message: '请填写积分平台商品ID'
  }],
  name: [{
    required: true,
    trigger: ['blur', 'change'],
    message: '请输入商品名称'
  }],
  image: [{
    required: true,
    trigger: ['blur', 'change'],
    message: '请选择商品图片'
  }],
  price: [{
    required: true,
    trigger: ['blur', 'change'],
    message: '请输入商品价格'
  }]
};